export default "/images/vendor/flag-icon-css/flags/4x3/pk.svg?8f9276eb2e7dc3eac94d57ec63ea2818";